import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { fetchType } from "../redux/actions/typeAction"
import { Autocomplete, TextField, Button, Paper } from '@mui/material';
import Swal from "sweetalert2"
import Download from "downloadjs";
import { typeAPI } from "../services/TypeAPI";
import { makeStyles } from "@material-ui/core/styles";
import './decument.css'

const Document = ({ isMobile, closeNav }) => {

    const { user: { isLogin, isLoading, userData }, type: { isLoadingType, DataType } } = useSelector(state => state)
    const dispatch = useDispatch()
    const [selectType, setSelectType] = useState(null)
    const [selectYear, setSelectYear] = useState(null)
    const [count, setCount] = useState(0)

    useEffect(() => {
        if (isLogin) {
            dispatch(fetchType())
        }
    }, [isLogin])

    useEffect(() => {
        if (selectYear) {
            setSelectYear(null)
        }
    }, [selectType])

    useEffect(() => {
        if (count >= 5) {
            Swal.close()
        }
    }, [count])

    const DownloadFile = () => {
        if (selectType && selectYear) {
            Swal.fire({
                title: "โปรดป้อนรหัสผ่าน",
                input: "password",
                inputAttributes: {
                    autocapitalize: "off"
                },
                confirmButtonColor: "#6ab23a",
                showCancelButton: true,
                confirmButtonText: "ยืนยัน",
                showLoaderOnConfirm: true,
                cancelButtonText: "ยกเลิก",
                preConfirm: (password) => {
                    try {
                        if (!password) throw { message: "ป้อนรหัสผ่าน เพื่อดาวน์โหลดเอกสาร" }
                        return typeAPI
                            .DownloadFile({ password, type: selectType._id, year: selectYear })
                            .then(response => {
                                if (response.status != 200) {
                                    throw new Error(response.status);
                                }
                                return response;
                            })
                            .catch(error => {
                                const SwitchErrorCode = (errorcode) => {
                                    try {
                                        let errorStr = errorcode.toString()
                                        if (errorStr == "Error: Request failed with status code 405") {
                                            setCount((old) => old + 1)
                                        }
                                        switch (errorStr) {
                                            case "Error: Request failed with status code 405": return "รหัสผ่านไม่ถูกต้อง"
                                            case "Error: Request failed with status code 402": return "ไฟล์ประเภทนี้ไม่ถูกเปิดให้ Download"
                                            case "Error: Request failed with status code 403": return "ไม่พบ User ในระบบหรืออาจถูกบล็อคติดต่อ HR"
                                            case "Error: Request failed with status code 404": return "ไม่พบไฟล์"
                                            case "Error: Request failed with status code 502": return "Bad Gateway"
                                            default: return "ไม่พบไฟล์"
                                        }
                                    } catch (error) {
                                        return "ไม่พบไฟล์"
                                    }
                                }
                                Swal.showValidationMessage(SwitchErrorCode(error.message));
                            });
                    } catch (error) {
                        Swal.showValidationMessage(error.message);
                    }
                },
                allowOutsideClick: () => !Swal.isLoading()
            }).then(result => {
                Download(
                    result.value.data,
                    `${userData.username}.pdf`,
                    result.value.headers["content-type"]
                );
            });
        }
    }

    const useStyles = makeStyles(theme => ({
        root: {
            padding: theme.spacing(4, 3)
        },
    }));

    const classes = useStyles();

    return (
        !isLoading && <div className='container h-100vh' style={{ display: closeNav ? 'flex' : isMobile ? 'none' : 'flex', marginTop: !isMobile ? 0 : '70px', justifyContent: 'flex-start', padding: '0' }}>
            <Paper className={`${classes.root} paper-root`} style={{ boxShadow: 'none', width: '85%', padding: '3%' }}>
                <h3 style={{ fontSize: '38px' }}>ขอเอกสาร</h3>
                <div className={`${classes.enter} enter-text`} style={{ paddingTop: '4%' }}>
                    <Autocomplete className={`${classes.Autocomplete} auto-root`}
                        style={{ width: '50%', margin: '0', }}
                        loading={isLoadingType}
                        onChange={(event, newValue) => {
                            setSelectType(newValue)
                        }}
                        options={DataType}
                        renderOption={(props, option) => {
                            return (
                                <li {...props} key={option._id}>
                                    {option.name}
                                </li>
                            );
                        }}
                        getOptionLabel={(option) => option.name || ""}
                        isOptionEqualToValue={(option) => option.name == selectType?.name}
                        renderInput={(params) => (
                            <TextField {...params} label="เลือกประเภทเอกสาร..." variant="standard" />
                        )}
                    />
                    {selectType &&
                        <Autocomplete className={`${classes.Autocomplete} auto-root`}
                            style={{ width: '50%', margin: '0', marginTop: '24px' }}
                            loading={isLoadingType}
                            value={selectYear}
                            onChange={(event, newValue) => {
                                setSelectYear(newValue)
                            }}
                            options={selectType.path}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} key={option}>
                                        {`ปี - ${option}`}
                                    </li>
                                );
                            }}
                            getOptionLabel={(option) => option || ""}
                            isOptionEqualToValue={(option) => option == selectYear}
                            renderInput={(params) => (
                                <TextField {...params} label="เลือกปีเอกสาร..." variant="standard" />
                            )}
                        />}
                    <div style={{ display: 'flex', marginTop: isMobile ? '20%' : '6%', justifyContent: 'flex-start' }}>
                        {count < 5 && <Button
                            variant="contained"
                            style={{
                                textTransform: 'none', backgroundColor: selectYear ? "#6ab23a" : "lightgray", margin: '0', color: 'white', cursor: 'pointer', padding: '10px 24px'
                            }}
                            disabled={selectYear ? false : true}
                            onClick={DownloadFile}
                        >
                            <i className="bx bxs-file-pdf icon" style={{ margin: '0', paddingRight: '10px' }} />{" "}ดาวน์โหลดเอกสาร
                        </Button>}
                    </div>
                </div>
            </Paper>
        </div>
    )
}
export default Document